import { get, post } from '@/fn/ajax'
import { clean } from '@/fn/object'

export async function fetchStudentList(data: any) {
    const res = await post('/api/classes/studentListByClass', data)
    return res
}

export async function createStudent(data: any) {
    const res = await post('/api/classes/addStudent', data)
    return res
}

export async function getAllStudentByClass(data: any) {
    const res = await post('/api/classes/getStudentList', data)
    return res
}
export async function editStudent(data: any) {
    const res = await post('/api/classes/editStudent', data)
    return res
}
export async function getAllClass(data: any) {
    const res = await post('/api/classes/getClsssList', data)
    return res
}
export async function removeStudent(data: any) {
    const res = await post('/api/classes/moveStudent', data)
    return res
}
export async function checkStuNumber(data: any) {
    const res = await post('/api/classes/checkStuNumber', data)
    return res
}
export async function batchAddStudent(data: any) {
    const res = await post('/api/classes/batchAddStudent', data)
    return res
}




